import { useContext, useEffect, useRef } from 'react';
import { AuthContext, ApiClientService, useApiClient } from 'libs.react_internal';
import { DEPLOYMENT_STATUS } from '../../constants/deployment.constants';
export const useJobChecker = () => {
    const { entityId } = useContext(AuthContext);
    const momClient = useApiClient(ApiClientService.MOM);
    // Track all active polling intervals for proper cleanup
    const activeIntervalsRef = useRef(new Set());
    /**
     * Clean up all active intervals when the component is unmounted
     */
    useEffect(() => {
        return () => {
            activeIntervalsRef.current.forEach((intervalId) => clearInterval(intervalId));
            activeIntervalsRef.current.clear();
        };
    }, []);
    const checkJobStatus = async (jobId, { interval = 1000, onInterval } = {}) => {
        const initialJobResponse = await getJobStatus(jobId);
        if (initialJobResponse.status === DEPLOYMENT_STATUS.CREATED ||
            initialJobResponse.status === DEPLOYMENT_STATUS.ACTIVE) {
            return await new Promise((resolve) => {
                // Each call gets its own interval ID to prevent orphaning
                const intervalIdRef = { current: 0 };
                const endPolling = (response) => {
                    clearInterval(intervalIdRef.current);
                    activeIntervalsRef.current.delete(intervalIdRef.current);
                    if (response) {
                        resolve(response);
                    }
                };
                intervalIdRef.current = setInterval(async () => {
                    const jobResponse = await getJobStatus(jobId);
                    if (onInterval) {
                        onInterval(jobId, jobResponse, endPolling);
                    }
                    if (jobResponse.status !== DEPLOYMENT_STATUS.CREATED && jobResponse.status !== DEPLOYMENT_STATUS.ACTIVE) {
                        endPolling(jobResponse);
                    }
                }, interval);
                // Track this interval for cleanup on unmount
                activeIntervalsRef.current.add(intervalIdRef.current);
            });
        }
        return initialJobResponse;
    };
    const getJobStatus = async (jobId) => {
        const { data: statusResponse } = await momClient.get(`/v1/entities/${entityId}/workflows/${jobId}`);
        return statusResponse.data;
    };
    return { checkJobStatus, getJobStatus };
};
